import {
  lotPartieDeLotFromLotSegment,
  stripPartieSuffixFromLotSegment,
} from '../components/form/u3141ChildLotChain/U3141ConcordanceUtils';

/** Libellé lot sur les nœuds du graphe — suffixe `(ptie)` si partie de lot. */
export function u3141FormatLotGraphLabel(lot: string | undefined | null, partieDeLot?: boolean | null): string {
  const raw = lot?.trim() ?? '';
  if (!raw) return '';
  return partieDeLot === true ? `${raw} (ptie)` : raw;
}

/** Numéro affiché dans les dialogues graphe (case « Partie de lot » à part — sans `(ptie)`). */
export function u3141FormatLotGraphDialogLotNumber(lot: string | undefined | null): string {
  return stripPartieSuffixFromLotSegment(lot?.trim() ?? '');
}

/** Colonne « Numéro de lot » de l’autocomplete ajout graphe — `(ptie)` si partie de lot. */
export function u3141FormatGraphAddLotAutocompleteLotCell(lot: string | undefined | null, partieDeLot?: boolean | null): string {
  const raw = lot?.trim() ?? '';
  if (!raw) return '';
  const isPartie = partieDeLot === true || lotPartieDeLotFromLotSegment(raw);
  return u3141FormatLotGraphLabel(stripPartieSuffixFromLotSegment(raw), isPartie);
}

function u3141CoercePartieDeLotFlag(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1';
}

/** Item autocomplete U3142 — lit `partieDeLot` / `partie_de_lot` / suffixe dans `lot`. */
export function u3141FormatGraphAddLotAutocompleteLotCellFromSearchItem(
  item: { lot?: string | null; partieDeLot?: boolean | null; value?: unknown } & Record<string, unknown>,
): string {
  const lotRaw = String(item.lot ?? item.value ?? '').trim();
  if (!lotRaw) return '';
  const isPartie =
    u3141CoercePartieDeLotFlag(item.partieDeLot) ||
    u3141CoercePartieDeLotFlag(item.partie_de_lot) ||
    lotPartieDeLotFromLotSegment(lotRaw);
  return u3141FormatLotGraphLabel(stripPartieSuffixFromLotSegment(lotRaw), isPartie);
}
